import {
  ExperienceBrandEntity,
  ExperienceEnterpriseEntity,
  ExperienceEntity,
  ExperienceEntityTree,
  ExperienceEntityType,
  ExperienceMerchantEntity,
  ExperienceVenueEntity,
} from './types';

export const getInitials = (label: string) =>
  label
    .split(' ')
    .slice(0, 2)
    .map(word => word.charAt(0))
    .join('');

type Entity<T extends ExperienceEntityType> = T extends ExperienceEntityType.VENUE
  ? ExperienceVenueEntity
  : T extends ExperienceEntityType.MERCHANT
    ? ExperienceMerchantEntity
    : T extends ExperienceEntityType.BRAND
      ? ExperienceBrandEntity
      : T extends ExperienceEntityType.ENTERPRISE
        ? ExperienceEnterpriseEntity
        : never;

const isEntityOfType = <T extends ExperienceEntityType>(
  experienceEntity: ExperienceEntity,
  experienceEntityType: T,
): experienceEntity is Entity<T> => experienceEntity.experienceEntityType === experienceEntityType;

export const recursiveGetOfType = <T extends ExperienceEntityType>(
  experienceEntityTree: ExperienceEntityTree,
  experienceEntityType: T,
): Entity<T>[] => {
  if (isEntityOfType(experienceEntityTree.experienceEntity, experienceEntityType)) {
    return [experienceEntityTree.experienceEntity];
  }

  return experienceEntityTree.children.flatMap((child: ExperienceEntityTree) =>
    recursiveGetOfType(child, experienceEntityType),
  );
};

export const recursiveFindEntity = (
  experienceEntityTree: ExperienceEntityTree,
  experienceEntityId: string,
): ExperienceEntityTree | undefined => {
  if (experienceEntityTree.experienceEntity.experienceEntityId === experienceEntityId) {
    return experienceEntityTree;
  }

  return experienceEntityTree.children
    .map((child: ExperienceEntityTree) => recursiveFindEntity(child, experienceEntityId))
    .find(Boolean);
};
